import React, { FC } from 'react';
import { GAME } from '../../../../constants/links';
import { Button } from '@mui/material';
import { getUserId, userIsLogged } from '../../../Login/helpers/storage';
import { useTypedSelector } from '../../../../hooks/useTypesSelector';
import { useActions } from '../../../../hooks/useAction';
import { useNavigate } from 'react-router-dom';

interface GameListProps {
  page: number;
  group: number;
}
export const GameList: FC<GameListProps> = ({ page, group }) => {
  const userMessage = useTypedSelector((state) => state.auth.user.message);
  const { fetchFilteredAudioWords, fetchFilteredUsersWordsSprint } = useActions();
  const userId = getUserId() || '';
  const navigate = useNavigate();

  const handeleClickGame = (title: string) => {
    if (title === 'Аудиовызов') {
      if (!userIsLogged(userMessage)) {
      }
      if (userIsLogged(userMessage)) {
        fetchFilteredAudioWords(userId, group, page);
      }
      navigate('/game/audio');
    } else {
      if (userIsLogged(userMessage)) {
        fetchFilteredUsersWordsSprint(userId, group, page);
      }
      navigate('/game/sprint');
    }
  };
  return (
    <>
      {GAME.map((it) => {
        const { img, text, title, to } = it;
        return (
          <div key={text}>
            <Button variant="contained" color="primary" onClick={() => handeleClickGame(title)}>
              {title}
            </Button>
          </div>
        );
      })}
    </>
  );
};
